import { pBase } from './.catalog';

export default class pOtpAl extends pBase {
  constructor(options: { KullaniciAdi?: string; otp?: string; Telefon?: string }) {
    super();
    this.KullaniciAdi = options.KullaniciAdi;
    this.Telefon = options.Telefon;
  }

  public KullaniciAdi: string | undefined;
  public Telefon: string | undefined;
}
